import LoaderIndicator from './LoaderIndicator';

export default LoaderIndicator;
